import Task from "../../../classes/Task";
import { db } from "../../../boot/firebase";
import {
  addDoc,
  collection,
  doc,
  setDoc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";

export const GET_TASK = async ({ dispatch }, { projectID, taskID }) => {
  const path = Task.getPath(projectID, taskID);
  return dispatch("GET_DOC", {
    converter: Task,
    path,
    stateKey: "tasks",
    stateID: Task.getStateID(path),
  });
};

export const LISTEN_TASK = (
  { dispatch },
  { projectID, taskID, next, error, unlisten, retain }
) => {
  const path = Task.getPath(projectID, taskID);
  return dispatch("LISTEN_DOC", {
    converter: Task,
    path,
    stateKey: "tasks",
    id: Task.getStateID(path),
    next,
    error,
    unlisten,
    retain,
  });
};

export const LISTEN_PROJECT_TASKS = (
  { dispatch },
  { projectID, listenerPath, error, next, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: Task,
    stateKey: "tasks",
    path: Task.getPath(projectID),
    listenerPath,
    next,
    error,
    unlisten,
  });
};

// Every project's tasks (a collection-group query), filtered by
// `conditions` — `[[field, op, value], …]`, as LISTEN_COLLECTION reads them.
export const LISTEN_TASKS = (
  { dispatch },
  { conditions, listenerPath, error, next, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: Task,
    stateKey: "tasks",
    colGroup: "tasks",
    listenerPath,
    conditions,
    next,
    error,
    unlisten,
  });
};

export const SAVE_TASK = async ({ state }, { projectID, task }) => {
  if (!task.id) {
    // New Task
    task.data.created = new Date();
    task.data.createdBy = state.user.id;
    task.data.assignedBy = state.user.id;
    const colRef = collection(db, Task.getPath(projectID)).withConverter(Task);
    const docRef = await addDoc(colRef, task);
    task.id = docRef.id;
  } else {
    // Existing Task
    task.data.modified = new Date();
    task.data.modifiedBy = state.user.id;
    await setDoc(doc(db, task.path).withConverter(Task), task);
  }
  return task;
};

export const COMPLETE_TASK = async ({ state }, { projectID, taskID }) => {
  await updateDoc(doc(db, Task.getPath(projectID, taskID)), {
    status: "complete",
    completedAt: new Date(),
    completedBy: state.user.id,
    modified: new Date(),
    modifiedBy: state.user.id,
  });
};

export const REOPEN_TASK = async ({ state }, { projectID, taskID }) => {
  await updateDoc(doc(db, Task.getPath(projectID, taskID)), {
    status: "open",
    completedAt: null,
    completedBy: null,
    modified: new Date(),
    modifiedBy: state.user.id,
  });
};

export const SKIP_TASK = async ({ state }, { projectID, taskID }) => {
  await updateDoc(doc(db, Task.getPath(projectID, taskID)), {
    status: "skipped",
    skippedAt: new Date(),
    skippedBy: state.user.id,
    modified: new Date(),
    modifiedBy: state.user.id,
  });
};

export const DECLINE_TASK = async (
  { state },
  { projectID, taskID, reason }
) => {
  await updateDoc(doc(db, Task.getPath(projectID, taskID)), {
    status: "declined",
    declinedAt: new Date(),
    declinedBy: state.user.id,
    declineReason: reason || "",
    modified: new Date(),
    modifiedBy: state.user.id,
  });
};

export const DELETE_TASK = async (context, { projectID, taskID }) => {
  return deleteDoc(doc(db, Task.getPath(projectID, taskID)));
};
